import React from 'react'
import BlueHeading from '../other/common/BlueHeading';
import Heading from '../common/ui/Heading';

const Empowering = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="w-full max-w-[871px] mx-auto">
          <div className="flex items-center justify-center flex-col">
            <BlueHeading text="Empowering Change" />
            <Heading children="Transforming Through Words" className='text-center' />
            <p className="text-center text-[#5E5C5C] text-[26px] pt-4 max-md:text-2xl max-sm:text-xl font-normal leading-[150%]">
              Deepak Ji believes that "Sometimes a single thought, a single
              article can change an entire life."
            </p>
            <p className="text-center text-[#5E5C5C] text-[26px] max-md:text-2xl max-sm:text-xl font-normal leading-[150%]">
              Each of his writings is crafted with a purpose — to awaken minds
              and to inspire the soul.
            </p>
          </div>
        </div>
          </div>
          <div className='h-[210px]'></div>
    </>
  );
}

export default Empowering